import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import type { Option } from 'modules/core/components/Popover/Content'

interface Props {
  actions: Option[]
}

const Options = ({ actions }: Props) => {
  const [open, toggle] = useToggle(false)

  if (!actions.length) return null

  return (
    <Popover attachment="top center" toggle={toggle} open={open}>
      <Button type="secondary" onClick={toggle(true)} iconName="settings" />
      <PopoverContent onClose={toggle(false)} options={actions} />
    </Popover>
  )
}

export default Options
